import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Chiudi il menu mobile al cambio pagina
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Diensten', path: '/diensten' },
    { name: 'Foto\'s', path: '/photos' },
    { name: 'Over Mij', path: '/about' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled || mobileOpen ? 'bg-white shadow-sm' : 'bg-white/90 backdrop-blur-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/7b34421e175c8bb5abddaf2fbf57a1a1/f42521aa7e409b8f2cc1069ded55932c.jpeg" 
              alt="NGP Renovatieproject Logo" 
              className="h-12 w-12 object-contain"
            />
            <div className="flex flex-col">
              <span className="text-xl font-bold text-gray-900">NGP</span>
              <span className="text-xs text-gray-600">Renovatieproject</span>
            </div>
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link, index) => (
              <div key={link.path} className="flex items-center gap-8">
                <Link
                  to={link.path}
                  className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    location.pathname === link.path
                      ? 'text-gray-900'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  {link.name}
                </Link>
                {index < navLinks.length - 1 && (
                  <span className="text-gray-300">◆</span>
                )}
              </div>
            ))}
          </div>

          <Link
            to="/offerte"
            className="hidden md:flex items-center gap-2 bg-gray-900 text-white px-6 py-3 rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Offerte Aanvragen
            <i className="ri-arrow-right-line"></i>
          </Link>

          {/* Hamburger button */}
          <button
            className="md:hidden text-gray-900 w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(prev => !prev)}
            aria-label="Toggle menu"
          >
            <i className={`text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="flex flex-col px-6 py-4 gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`py-3 text-base font-medium border-b border-gray-100 transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-gray-900'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/offerte"
              className="mt-4 flex items-center justify-center gap-2 bg-gray-900 text-white px-6 py-3 rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              Offerte Aanvragen
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
